/**
 * Created by amine on 09/06/2021.
 */
(function () {
    'use strict';

    class sportDataService {
        constructor($q, mnWebSocket, $http) {
            this.q = $q;
            this.ws = mnWebSocket;
            this.http = $http;

            this.baseUrl = "/api/s/"
        }

        static get $inject() {
            return ["$q", "mnWebSocket", "$http"];
        }

        getOrganizations() {
            const deferred = this.q.defer();

            this.http.get(`${this.baseUrl}organization/`)
                .then(response => deferred.resolve(response.data), deferred.reject)

            return deferred.promise;
        }

        saveOrganization(model) {
            let deferred = this.q.defer();

            this.http.post(this.getUrl(model.id, "organization"), model)
                .then(response => deferred.resolve(response.data), deferred.reject);

            return deferred.promise;
        }

        deleteOrganization(item) {
            const deferred = this.q.defer();

            this.http.delete(this.getUrl(item.id, "organization"))
                .then(response => deferred.resolve(response.data), deferred.reject)

            return deferred.promise;
        }

        getSportFileHistory(patient) {
            return this.ws.call('specifics.sport_data.SportFile.versions', {patient});
        }

        getActiveSportFile(patient, maxDate) {
            const query = _.assign({patient}, _.isNil(maxDate) ? {} : {max_date: maxDate});
            return this.ws.call('specifics.sport_data.SportFile.active_version', query);
        }

        getSportFile(version) {
            const deferred = this.q.defer();

            this.http.get(this.getUrl(version), 'file')
                .then(response => {
                        deferred.resolve(response.data);
                    },
                    deferred.reject
                );

            return deferred.promise;
        }

        handleSportFile(file) {
            const deferred = this.q.defer();

            this.http[file.id ? 'put' : 'post'](this.getUrl(file.id, 'file'), file)
                .then(response => {
                    deferred.resolve(response.data);
                }, deferred.reject);

            return deferred.promise;
        }

        getUrl(modelId, view, prefix = "") {
            return `${this.baseUrl}${view}/${modelId ? `${modelId}/` : ''}${prefix ? `${prefix}/` : ''}`;
        }
    }

    module.exports = sportDataService;
})();